import { render, staticRenderFns } from "./addEditAccountTem.vue?vue&type=template&id=962bc748&scoped=true"
import script from "./addEditAccountTem.vue?vue&type=script&lang=js"
export * from "./addEditAccountTem.vue?vue&type=script&lang=js"
import style0 from "./addEditAccountTem.vue?vue&type=style&index=0&id=962bc748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962bc748",
  null
  
)

export default component.exports